import { render, staticRenderFns } from "./ExpenseUpdate.vue?vue&type=template&id=55b0f5e2"
import script from "./ExpenseUpdate.vue?vue&type=script&lang=js"
export * from "./ExpenseUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports